<template>
    <div>
        <vue-multiselect
            v-model="selectedOption"
            class="w-100"
            :options="options"
            :placeholder="placeholder"
            :tag-placeholder="tagPlaceholder"
            :taggable="taggable"
            :show-labels="false"
            :track-by="trackBy"
            :label="label"
            :multiple="multiple"
            :disabled="disabled"
            :searchable="searchable"
            @select="selectItem($event)"
            @remove="removeItem($event)"
            @tag="addNewItem($event)"
        ></vue-multiselect>
    </div>
</template>
<script>

export default {
    props: {
        modelValue: {
            type: [String, Object, Array, null, Number],
            default: null
        },
        placeholder: {
            type: String,
            default: 'Search or add new item'
        },
        tagPlaceholder: {
            type: String,
            default: 'Add this as new items'
        },
        items: {
            type: Array,
            default: []
        },
        taggable: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        searchable: {
            type: Boolean,
            default: true
        },
        trackBy: {
            type: String,
            default: 'name'
        },
        label: {
            type: String,
            default: 'name'
        },
    },
    data() {
        return {
            options: this.items,
            selectedOption: null,
        }
    },
    mounted() {
        this.prepareSelectedOption();
    },
    computed: {

    },
    watch: {
        modelValue(newVal) {
            this.prepareSelectedOption();
        },
        items(newItems) {
            // Update options if items prop changes
            this.options = newItems;
            this.prepareSelectedOption();
        },
    },
    methods: {
        addNewItem(newService) {
            let tag = {
                id: '',
                name: newService,
            };
            this.selectedOption = tag;
            this.options.push(tag);

            // Update service name to parent component
            this.$emit('update:modelValue', "");
            this.$emit('updateLabel', newService);
        },
        selectItem(event) {
            let serviceId = event.id;
            let serviceName = event.name;
            // Check if multiple selection is enabled and this.modelValue is an array
            // Then get the ids from the selected option
            if (this.multiple && Array.isArray(this.modelValue)) {
                serviceId = this.selectedOption.map(option => option.id);
            }

            this.$emit('update:modelValue', serviceId);
            this.$emit('updateLabel', serviceName);
            this.$emit('selectOption', {});
            this.$emit('onSelectOption', event);
        },

        removeItem(event) {
            // Get the all ids from the selected option
            const ids = this.selectedOption ? this.selectedOption.map(option => option.id) : [];
            this.$emit('update:modelValue', ids);
            this.$emit('onRemoveOption', event);
        },
        prepareSelectedOption() {
            // Check if multiple selection is enabled and this.modelValue is an array
            if (this.multiple && Array.isArray(this.modelValue)) {
                this.selectedOption = this.options.filter(option =>
                    this.modelValue.includes(option.id)
                );
            }
            else {
                this.selectedOption = this.options.filter(option =>
                    this.modelValue==option.id
                );
            }
        }
    }
}
</script>
